import { render, staticRenderFns } from "./custom_export_fields.vue?vue&type=template&id=b54035a2&scoped=true&lang=pug"
import script from "./custom_export_fields.vue?vue&type=script&lang=js"
export * from "./custom_export_fields.vue?vue&type=script&lang=js"
import style0 from "./custom_export_fields.vue?vue&type=style&index=0&id=b54035a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54035a2",
  null
  
)

export default component.exports